(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("core-polyfills-legacy", [], factory);
	else if(typeof exports === 'object')
		exports["core-polyfills-legacy"] = factory();
	else
		root["core-polyfills-legacy"] = factory();
})(window, function() {
return 